
    import { defineComponent } from 'vue'
    import { createValidations } from '@/helpers/commons/validationHelper'
    import Dialog from 'primevue/dialog'
    import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
    import workspaceDataCloneDialogDescriptor from './WorkspaceDataCloneDialogDescriptor.json'
    import useValidate from '@vuelidate/core'

    export default defineComponent({
        name: 'workspace-repository-move-dialog',
        components: { Dialog, KnValidationMessages },
        props: { visible: { type: Boolean }, propDataset: { type: Object } },
        emits: ['close', 'clone'],
        data() {
            return {
                v$: useValidate() as any,
                workspaceDataCloneDialogDescriptor,
                dataset: {} as any
            }
        },
        validations() {
            return {
                dataset: createValidations('dataset', workspaceDataCloneDialogDescriptor.validations.dataset)
            }
        },
        watch: {
            propDataset() {
                this.loadDataset()
            }
        },
        computed: {
            labelHelp(): string {
                return (this.dataset.label?.length ?? '0') + ' / ' + workspaceDataCloneDialogDescriptor.labelMaxLength
            },
            nameHelp(): string {
                return (this.dataset.name?.length ?? '0') + ' / ' + workspaceDataCloneDialogDescriptor.nameMaxLength
            },
            descriptionHelp(): string {
                return (this.dataset.description?.length ?? '0') + ' / ' + workspaceDataCloneDialogDescriptor.descriptionMaxLength
            },
            buttonDisabled(): any {
                return this.v$.$invalid
            }
        },
        created() {
            this.loadDataset()
        },
        methods: {
            loadDataset() {
                if (this.propDataset) {
                    this.dataset = { ...this.propDataset, id: '', dsVersions: [], usedByNDocs: 0, name: 'CLONE_' + this.propDataset.name, label: 'CLONE_' + this.propDataset.label, description: this.propDataset.description ? 'CLONED ' + this.propDataset.description : '', scopeCd: 'USER' }
                    this.dataset.owner = (this.$store.state as any).user.userId
                    if (this.dataset.catTypeId) {
                        delete this.dataset.catTypeId
                    }
                }
            },
            closeDialog() {
                this.loadDataset()
                this.v$.$reset()
                this.$emit('close')
            },
            cloneDataset() {
                this.$emit('clone', this.dataset)
                this.loadDataset()
                this.v$.$reset()
            }
        }
    })
